if (!customElements.get('bg-related-products')) {
  customElements.define('bg-related-products', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.track = this.querySelector('[data-related-track]');
      this.cards = [...this.querySelectorAll('[data-related-card]')];
      this.previous = this.querySelector('[data-related-previous]');
      this.next = this.querySelector('[data-related-next]');
      if (!this.track) return;
      this.setAttribute('data-ready', '');
      const controls = this.querySelector('[data-related-controls]');
      if (controls) controls.hidden = false;
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.goTo(0);
        else if (event.key === 'End') this.goTo(this.cards.length - 1);
        else this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.addEventListener('submit', (event) => this.addToCart(event), options);
      this.addEventListener('change', (event) => this.changeVariant(event), options);
      this.observer?.disconnect();
      this.observer = new ResizeObserver(() => this.updateControls());
      this.observer.observe(this.track);
      this.updateControls();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }

    updateControls() {
      if (!this.previous || !this.next) return;
      const left = this.track.getBoundingClientRect().left;
      this.index = this.cards.reduce((nearest, card, index) =>
        Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[nearest].getBoundingClientRect().left - left) ? index : nearest, 0);
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.cards.length - 1;
      this.querySelector('[data-related-index]').textContent = this.index + 1;
    }

    move(direction) {
      this.updateControls();
      this.goTo(Math.min(this.cards.length - 1, Math.max(0, this.index + direction)));
    }

    goTo(index) {
      const offset = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left: this.track.scrollLeft + offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    changeVariant(event) {
      if (!event.target.matches('[data-related-variant]')) return;
      const option = event.target.selectedOptions[0];
      const form = event.target.form;
      const card = form.closest('[data-related-card]');
      const price = card.querySelector('[data-related-price]');
      price.querySelector('[data-related-current-price]').textContent = option.dataset.price;
      price.querySelector('[data-related-compare-value]').textContent = option.dataset.comparePrice;
      price.querySelector('[data-related-compare-price]').hidden = !option.dataset.comparePrice;
      price.toggleAttribute('data-sale', !!option.dataset.comparePrice);
      form.elements.quantity.value = option.dataset.quantity;
      form.querySelector('[type=submit]').disabled = option.disabled;
      form.querySelector('[data-related-button-text]').textContent = option.disabled ? this.dataset.soldOut : this.dataset.add;
      form.querySelector('[data-related-error]').hidden = true;
      form.querySelector('[data-related-success]').hidden = true;
    }

    async addToCart(event) {
      const form = event.target.closest('form');
      if (!form || !this.contains(form)) return;
      event.preventDefault();
      const button = form.querySelector('[type=submit]');
      if (this.pending || button.disabled) return;
      this.pending = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      const error = form.querySelector('[data-related-error]');
      const success = form.querySelector('[data-related-success]');
      error.hidden = true;
      success.hidden = true;
      const select = form.querySelector('select');
      if (select) select.disabled = true;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const data = new FormData(form);
      if (select) data.set('id', select.value);
      const sections = cart?.getSectionsToRender() || [];
      if (sections.length) {
        data.set('sections', sections.map(section => section.id).join(','));
        data.set('sections_url', window.location.pathname);
        cart.setActiveElement(button);
      }
      let rejectedMessage;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          rejectedMessage = typeof result.description === 'string' ? result.description : this.dataset.error;
          throw new Error(rejectedMessage);
        }
        success.querySelector('[data-related-success-text]').textContent = this.dataset.added;
        success.hidden = false;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bg-related-products', productVariantId: data.get('id'), cartData: result });
        }
        if (cart && sections.every(section => result.sections?.[section.id])) {
          try {
            cart.classList.remove('is-empty');
            cart.renderContents(result);
          } catch {
            success.querySelector('a').focus();
          }
        }
      } catch (failure) {
        error.textContent = rejectedMessage || this.dataset.error;
        error.hidden = false;
      } finally {
        this.pending = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (select) select.disabled = false;
      }
    }
  });
}
